import * as React from 'react';
import { isAndroid, isHermes, isIOS } from '../fastflowUtils';
import { IWithResponsiveProps, withResponsiveBrowserOnly } from '@snoam/pinata';

export const ResponsiveContext = React.createContext<{
  mobile: boolean;
  desktop: boolean;
  tablet: boolean;
  landscape?: boolean | undefined;
  portrait?: boolean | undefined;
  isHermes?: boolean | undefined;
  ios?: boolean | undefined;
  android?: boolean | undefined;
}>({
  android: undefined,
  desktop: false,
  ios: undefined,
  isHermes: undefined,
  landscape: undefined,
  mobile: false,
  portrait: undefined,
  tablet: false
});

const ResponsiveContextProvider = withResponsiveBrowserOnly<
  IWithResponsiveProps
>(props => {
  const { children, mobile, desktop, landscape, portrait, tablet } = props;
  const userAgent = navigator.userAgent;
  const state = {
    android: isAndroid(userAgent),
    desktop: Boolean(desktop),
    ios: isIOS(userAgent),
    isHermes: isHermes(userAgent),
    landscape,
    mobile: Boolean(mobile),
    portrait,
    tablet: Boolean(tablet)
  };
  return (
    <ResponsiveContext.Provider value={state}>
      {children}
    </ResponsiveContext.Provider>
  );
});

ResponsiveContextProvider.displayName = "ResponsiveContextProvider";

export default ResponsiveContextProvider;
